/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Ušetřete na nákupech na ${i.storeName}`
};

const da_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Spar på dine køb hos ${i.storeName}`
};

const de_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Sparen Sie beim Einkauf bei ${i.storeName}`
};

const en_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Save money when purchasing items on ${i.storeName}`
};

const es_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Ahorra en tus compras de artículos en ${i.storeName}`
};

const fr_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Economisez lors de vos achats d'articles sur ${i.storeName}`
};

const hu_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Takarítson meg a termékek vásárlásakor a ${i.storeName} -on`
};

const it_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Risparmia sui tuoi acquisti su ${i.storeName}`
};

const nl_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Bespaar op je aankopen bij ${i.storeName}`
};

const pl_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Oszczędzaj podczas zakupów w ${i.storeName}`
};

const pt_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Economize em suas compras de artigos na ${i.storeName}`
};

const sv_discount_codes_save_on_purchase = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Spara på dina köp hos ${i.storeName}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ storeName: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_save_on_purchase = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_save_on_purchase(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_save_on_purchase", locale)
	if (locale === "cs") return cs_discount_codes_save_on_purchase(inputs)
	if (locale === "da") return da_discount_codes_save_on_purchase(inputs)
	if (locale === "de") return de_discount_codes_save_on_purchase(inputs)
	if (locale === "en") return en_discount_codes_save_on_purchase(inputs)
	if (locale === "es") return es_discount_codes_save_on_purchase(inputs)
	if (locale === "fr") return fr_discount_codes_save_on_purchase(inputs)
	if (locale === "hu") return hu_discount_codes_save_on_purchase(inputs)
	if (locale === "it") return it_discount_codes_save_on_purchase(inputs)
	if (locale === "nl") return nl_discount_codes_save_on_purchase(inputs)
	if (locale === "pl") return pl_discount_codes_save_on_purchase(inputs)
	if (locale === "pt") return pt_discount_codes_save_on_purchase(inputs)
	return sv_discount_codes_save_on_purchase(inputs)
};
export { discount_codes_save_on_purchase as "discount_codes.save_on_purchase" }